export default class CST {
  constructor(id, codigo, descricao) {
    this.id = id
    this.codigo = codigo
    this.descricao = descricao
  }
}
